<script lang="ts">
    import { gameManager } from "../../../Phaser/Game/GameManager";
    import RoomUserList from "./RoomUserList.svelte";

    const gameScene = gameManager.getCurrentGameScene();
    const userProviderMergerPromise = gameScene.userProviderMerger;
</script>

{#await userProviderMergerPromise}
    <div></div>
{:then userProviderMerger}
    <RoomUserList {userProviderMerger} />
{/await}
